import GlobalComponents from './globalComponents';
import GlobalHelpers from './globalHelpers';

import VueMeta from 'vue-meta';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import VueMask from 'v-mask';

import VueCookies from 'vue-cookies'

// import router from '../routes/router';
// import VueAnalytics from 'vue-analytics';

export default {
    install(Vue) {
        Vue.use(GlobalComponents);
        Vue.use(GlobalHelpers);
        Vue.use(VueSweetalert2);
        Vue.use(VueMeta);
        Vue.use(VueMask);
        Vue.use(VueCookies)

        // Vue.use(VueAnalytics, {
        //     id: 'UA-178630887-1',
        //     router,
        //     ignoreRoutes: ['/trip/search/iframe','TripSearchIframe'],
        //     autoTracking: {
        //         page: false
        //     }
        // });
    }
}